import {OptInWinHighlightAmountMRGreenBox} from "./opt-in-win-highlight-amount.mrgreen.box";

export const OptInWinHighlightAmountMRGreenCisBox = OptInWinHighlightAmountMRGreenBox;